import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SageErrorFixStore } from './sage-error-fix.store';
import { SalesGroupItemsComponent } from './sales-group-items.component';

/** "No sales group chosen": one group for every item, saved as the default sales group, or a group per item. */
@Component({
  selector: 'app-sales-group-fix',
  standalone: true,
  imports: [CommonModule, SalesGroupItemsComponent],
  templateUrl: './sales-group-fix.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './fix-section.shared.css'],
})
export class SalesGroupFixComponent {
  @Input({ required: true }) store!: SageErrorFixStore;
  @Input() count = 0;
  @Input() syncEnabled = true;
  @Input() idPrefix = '';

  picked: number | null = null;
  eachOpen = false;

  get useLabel(): string {
    return this.count === 1 ? 'Use it for this item' : `Use it for all ${this.count}`;
  }

  use(): void {
    if (this.picked !== null) this.store.setDefault(this.picked);
  }
}
